import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type {
  ISettingsBookkeepingGetItemPayload,
  ISettingsBookkeepingGetItemResponse,
} from '@modules/general-settings/submodules/bookkeeping/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import {
  ADMIN_GENERAL_SETTINGS_BOOKKEEPING_PERMISSIONS,
  SETTINGS_BOOKKEEPING_GET_ITEM_QUERY_KEY,
  SETTINGS_BOOKKEEPING_GET_ITEM_URL,
} from '@modules/general-settings/submodules/bookkeeping/constants';
import { isSettingsBookkeepingGetItemPayload } from '@modules/general-settings/submodules/bookkeeping/guards/guards';
import { assert } from '@utils/guards';

export default function useSettingsBookkeepingListQuery(
  payload: Ref<ISettingsBookkeepingGetItemPayload | undefined>,
): IContextQueryResult<ISettingsBookkeepingGetItemResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<ISettingsBookkeepingGetItemResponse, Error>({
    queryKey: [SETTINGS_BOOKKEEPING_GET_ITEM_QUERY_KEY, payload],
    queryFn: async ({ signal }) => {
      assert(isSettingsBookkeepingGetItemPayload(payload.value));
      return fetchGet(SETTINGS_BOOKKEEPING_GET_ITEM_URL, {
        signal,
        permission: ADMIN_GENERAL_SETTINGS_BOOKKEEPING_PERMISSIONS.HISTORYOFLIMITCHANGES_EDIT,
        queryParams: { merchant: payload.value.merchantId },
        urlParams: {
          id: payload.value.id,
        },
      });
    },
    enabled: computed(() => !!payload.value),
  });
}
